export const BULK_UPLOAD_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  INPROGRESS: 'in_progress',
}
